/**
 * Rappel « ✏️ Pense à poser tes calculs sur ton brouillon » : le paragraphe
 * italique gris (`<p class="italic text-slate-400">…</p>`) que dix générateurs
 * ajoutent à leur énoncé (613, 615, 619, 1044, 1045, 1061…).
 *
 * Il ne sert qu'à l'ÉLÈVE SEUL DEVANT SON ÉCRAN. Il est retiré :
 *   - du papier (2026-09-03) : l'élève a sa feuille ;
 *   - de la projection (2026-09-12) : le prof est là, il donne ses consignes,
 *     et la ligne prend de la place à 60 px.
 */
export const RAPPEL_BROUILLON_RE = /<p class="italic text-slate-400">[\s\S]*?<\/p>/g;

export const sansRappelBrouillon = (html) => (
    typeof html === 'string' ? html.replace(RAPPEL_BROUILLON_RE, '') : html
);
